module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'autoship'
      }
    }
  }, [_vm._v("Mani Autoship pasūtījumi")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Rediģēt")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('skipped-goods-warning', {
    attrs: {
      "storeStatus": _vm.storeStatus
    }
  }), _vm._v(" "), (_vm.autoship.status == 0) ? _c('div', {
    staticClass: "ui warning icon message"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui form"
  }, [_c('h2', {
    staticClass: "ui dividing header"
  }, [_vm._v("AutoShip pasūtījums")]), _vm._v(" "), _c('div', {
    staticClass: "four fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Nosaukums")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Nosaukums"
    },
    domProps: {
      "value": _vm.autoship.autoship_name
    },
    on: {
      "change": function($event) {
        return _vm.updateAutoship('autoship_name', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "ui toggle checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "number": "",
      "value": "1"
    },
    domProps: {
      "checked": _vm.autoship.status == 1
    },
    on: {
      "change": function($event) {
        return _vm.updateAutoship('status', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("AutoShip statuss - "), (_vm.autoship.status == 1) ? _c('span', [_vm._v("Aktīvs")]) : _c('span', [_vm._v("Neaktīvs")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "four fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "ui toggle checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "number": "",
      "value": "1"
    },
    domProps: {
      "checked": _vm.autoship.pause == 1
    },
    on: {
      "change": function($event) {
        return _vm.updatePause($event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Uz laiku apturēt AutoShip")])])]), _vm._v(" "), (_vm.autoship.pause == 1) ? _c('div', {
    staticClass: "ui calendar field",
    attrs: {
      "id": "stop_from"
    }
  }, [_c('label', [_vm._v("Pārtraukt no")]), _vm._v(" "), _c('div', {
    staticClass: "ui input left icon"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Norādit datumu no"
    },
    domProps: {
      "value": _vm.autoship.pause_from
    },
    on: {
      "change": function($event) {
        return _vm.updateAutoship('pause_from', $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.autoship.pause == 1) ? _c('div', {
    staticClass: "ui calendar field",
    attrs: {
      "id": "stop_till"
    }
  }, [_c('label', [_vm._v("Pārtraukt līdz")]), _vm._v(" "), _c('div', {
    staticClass: "ui input left icon"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Norādit datumu līdz"
    },
    domProps: {
      "value": _vm.autoship.pause_to
    },
    on: {
      "change": function($event) {
        return _vm.updateAutoship('pause_to', $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Adrese")]), _vm._v(" "), _c('select', {
    staticClass: "ui fluid dropdown",
    on: {
      "change": function($event) {
        return _vm.changeDeliveryAddress($event.target.value)
      }
    }
  }, _vm._l((_vm.address), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id,
        "selected": item.id == _vm.autoship.address_id ? true : false
      }
    }, [_vm._v(_vm._s(item.street)), (item.house_no != '') ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(_vm._s(item.house_no)), (item.flat_no != '') ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(item.flat_no)), (item.city_label != '') ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(item.city_label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.showDeliveryZones
    }
  }, [_vm._v("Piegādes reģionu karte")]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Pasūtīšanas regularitāte")]), _vm._v(" "), _c('select', {
    staticClass: "ui fluid dropdown",
    attrs: {
      "id": "autoship_frequency"
    },
    on: {
      "change": function($event) {
        return _vm.updateAutoship('frequency', $event.target.value)
      }
    }
  }, [(_vm.checkIfAvailableForAddress(1)) ? _c('option', {
    attrs: {
      "value": "1"
    },
    domProps: {
      "selected": _vm.autoship.frequency == 1
    }
  }, [_vm._v("Reizi nedēļā")]) : _vm._e(), _vm._v(" "), (_vm.checkIfAvailableForAddress(2)) ? _c('option', {
    attrs: {
      "value": "2"
    },
    domProps: {
      "selected": _vm.autoship.frequency == 2
    }
  }, [_vm._v("Reizi divās nedēļās")]) : _vm._e(), _vm._v(" "), (_vm.checkIfAvailableForAddress(3)) ? _c('option', {
    attrs: {
      "value": "3"
    },
    domProps: {
      "selected": _vm.autoship.frequency == 3
    }
  }, [_vm._v("Reizi trīs nedēļās")]) : _vm._e(), _vm._v(" "), (_vm.checkIfAvailableForAddress(4)) ? _c('option', {
    attrs: {
      "value": "4"
    },
    domProps: {
      "selected": _vm.autoship.frequency == 4
    }
  }, [_vm._v("Reizi četrās nedēļās")]) : _vm._e(), _vm._v(" "), (_vm.checkIfAvailableForAddress(5)) ? _c('option', {
    attrs: {
      "value": "5"
    },
    domProps: {
      "selected": _vm.autoship.frequency == 5
    }
  }, [_vm._v("Reizi piecās nedēļās")]) : _vm._e(), _vm._v(" "), (_vm.checkIfAvailableForAddress(6)) ? _c('option', {
    attrs: {
      "value": "6"
    },
    domProps: {
      "selected": _vm.autoship.frequency == 6
    }
  }, [_vm._v("Reizi sešās nedēļās")]) : _vm._e(), _vm._v(" "), (_vm.checkIfAvailableForAddress(7)) ? _c('option', {
    attrs: {
      "value": "7"
    },
    domProps: {
      "selected": _vm.autoship.frequency == 7
    }
  }, [_vm._v("Reizi septiņās nedēļās")]) : _vm._e(), _vm._v(" "), (_vm.checkIfAvailableForAddress(8)) ? _c('option', {
    attrs: {
      "value": "8"
    },
    domProps: {
      "selected": _vm.autoship.frequency == 8
    }
  }, [_vm._v("Reizi astoņās nedēļās")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "ui calendar field",
    attrs: {
      "id": "start_date"
    }
  }, [_c('label', [_vm._v("Sākuma (nākamās piegādes) datums")]), _vm._v(" "), _c('div', {
    staticClass: "ui input left icon"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Norādit datumu no"
    },
    domProps: {
      "value": _vm.autoship.delivery_date
    }
  })])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui attached segment",
    class: {
      loading: _vm.storeStatus.loading
    }
  }, [_c('div', {
    staticClass: "ui form"
  }, [(_vm.itemsInCart > 0) ? _c('div', {
    staticClass: "ui divided items"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "ui tiny image",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push('/good/' + item.link)
        }
      }
    }, [(item.images[0]) ? _c('img', {
      attrs: {
        "src": item.images[0].url
      }
    }) : _c('img', {
      attrs: {
        "src": 'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/' + item.good_id + '.jpg'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('router-link', {
      staticClass: "header",
      attrs: {
        "to": '/good/' + item.link
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('div', {
      staticClass: "ui tag labels"
    }, [_c('a', {
      staticClass: "ui custom_brown label"
    }, [_vm._v("\n                Cena: " + _vm._s(item.price_vat) + " €\n              ")]), _vm._v(" "), (item.bail > 0) ? _c('a', {
      staticClass: "ui green label"
    }, [_vm._v("\n                Drošības nauda: " + _vm._s(item.bail) + " €\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_c('p', [_vm._v(_vm._s(item.description))])]), _vm._v(" "), _c('div', {
      staticClass: "extra"
    }, [(_vm.autoship.lock == 0) ? _c('button', {
      staticClass: "ui right floated grey icon button",
      on: {
        "click": function($event) {
          return _vm.removeItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "right trash icon"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ui right floated inline fields"
    }, [_c('label', [_vm._v("Pasūtīšu:   x ")]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('input', {
      staticStyle: {
        "width": "70px"
      },
      attrs: {
        "type": "text",
        "disabled": _vm.autoship.lock == 1,
        "placeholder": "skaits",
        "number": ""
      },
      domProps: {
        "value": item.order
      },
      on: {
        "keyup": function($event) {
          return _vm.updateCartItemOrder(item, $event.target.value)
        }
      }
    })])]), _vm._v(" "), _vm._l((item.badges), function(badge) {
      return _c('div', {
        staticClass: "ui label",
        style: ({
          backgroundColor: '#' + badge.color,
          color: '#210404'
        })
      }, [_vm._v(_vm._s(badge.label))])
    })], 2)], 1)])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.autoship.lock == 0) ? _c('div', {
    staticClass: "ui container"
  }, [_c('button', {
    staticClass: "ui right floated green button",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'autoship-add-goods',
          params: {
            id: _vm.autoship.id,
            page: 1
          }
        })
      }
    }
  }, [_vm._v("Pievienot preces")]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })])])], 1), _vm._v(" "), (_vm.itemsInCart > 0) ? _c('div', {
    staticClass: "ui secondary segment"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "ui two column grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ui column form"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Apmaksas veids")]), _vm._v(" "), _c('select', {
    staticClass: "ui fluid dropdown",
    on: {
      "change": function($event) {
        return _vm.updateAutoship('payment_type', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "3"
    },
    domProps: {
      "selected": _vm.autoship.payment_type == 3
    }
  }, [_vm._v("Skaidrā saņemot preci")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    },
    domProps: {
      "selected": _vm.autoship.payment_type == 2
    }
  }, [_vm._v("No konta")]), _vm._v(" "), (_vm.user.pay_later == 1) ? _c('option', {
    attrs: {
      "value": "5"
    },
    domProps: {
      "selected": _vm.autoship.payment_type == 5
    }
  }, [_vm._v("Pēcapmaksa")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Komentāri")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "rows": "4",
      "placeholder": "Šeit ierakstītā piezime parādīsies pie katra pasūtījuma"
    },
    domProps: {
      "value": _vm.autoship.notes
    },
    on: {
      "change": function($event) {
        return _vm.updateAutoship('notes', $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(_vm.autoship.details) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "ui list",
    staticStyle: {
      "text-align": "right",
      "margin-top": "30px"
    }
  }, [_vm._m(5), _vm._v(" "), (_vm.autoship.details.water_goods_price_vat > 0) ? _c('div', {
    staticClass: "item"
  }, [_vm._v("Ūdens 18,9l: " + _vm._s(_vm.autoship.details.water_goods_price_vat) + " €")]) : _vm._e(), _vm._v(" "), (_vm.autoship.details.services_price_vat > 0) ? _c('div', {
    staticClass: "item"
  }, [_vm._v("Pakalpojums: " + _vm._s(_vm.autoship.details.services_price_vat) + " €")]) : _vm._e(), _vm._v(" "), (_vm.autoship.details.no_water_goods_price_vat > 0) ? _c('div', {
    staticClass: "item"
  }, [_vm._v("Citas preces: " + _vm._s(_vm.autoship.details.no_water_goods_price_vat) + " €")]) : _vm._e(), _vm._v(" "), (_vm.autoship.details.bail != 0) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#E12F2E"
    }
  }, [_c('span', {
    attrs: {
      "id": "bail",
      "data-content": "Turpiniet, ievadot piegādes datumu un pārbaudiet veikto pasūtījumu. Ņemiet vērā, ka par katru lietošanā esošo pudeli jāmaksā drošības nauda. Drošības nauda tiks atgriezta pēc tukšo pudeļu atdošanas"
    }
  }, [_vm._v("Drošības nauda: " + _vm._s(_vm.autoship.details.bail) + " €")])]) : _vm._e(), _vm._v(" "), (_vm.autoship.details.deposit_amount != 0) ? _c('div', {
    staticClass: "item"
  }, [_c('span', {
    attrs: {
      "id": "deposit"
    }
  }, [_vm._v("Depozīts: " + _vm._s(_vm.autoship.details.deposit_amount) + " €")])]) : _vm._e(), _vm._v(" "), ((_vm.autoship.details.extra_delivery != 0) && (_vm.autoship.details.water_goods_price_vat > 0)) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#E12F2E"
    }
  }, [_c('span', {
    attrs: {
      "id": "delivery",
      "data-html": "Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR."
    }
  }, [_c('i', {
    staticClass: "info circle icon",
    attrs: {
      "data-html": "Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR."
    }
  }), _vm._v("Mainīgā degvielas piemaksa: " + _vm._s(_vm.autoship.details.extra_delivery) + " €")])]) : ((_vm.autoship.details.extra_delivery != 0)) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#E12F2E"
    }
  }, [_c('span', {
    attrs: {
      "id": "delivery",
      "data-html": "Piegādes maksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR."
    }
  }, [_vm._v("Piegāde: " + _vm._s(_vm.autoship.details.extra_delivery) + " €")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('b', [_vm._v("Kopsumma: " + _vm._s(_vm.autoship.details.total_price_with_bail_and_vat) + " €")])]), _vm._v(" "), (_vm.autoship.details.bonus > 0) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#21BA45"
    }
  }, [_c('span', {
    attrs: {
      "id": "bonus_autoship",
      "data-content": "Par katru Memory Water 18,9l pasūtījumu jūs saņemat 2% bio un citu veselīgu produktu iegādei"
    }
  }, [_vm._v("Bonuss: + " + _vm._s(_vm.autoship.details.bonus) + " € ")])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui right floated buttons"
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'autoship'
        })
      }
    }
  }, [_vm._v("Atpakaļ")]), _vm._v(" "), (_vm.autoship.lock == 0) ? _c('div', {
    staticClass: "or",
    attrs: {
      "data-text": "vai"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.autoship.lock == 0) ? _c('button', {
    staticClass: "ui custom_brown button",
    class: {
      disabled: _vm.autoship.delivery_date == ''
    },
    on: {
      "click": function($event) {
        return _vm.processAutoShip()
      }
    }
  }, [_vm._v("Saglabāt")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n         Informācijai\n       ")]), _vm._v(" "), _c('p', [_vm._v("Autoship ir apturēts, lai atjaunotu automātisku pasūtījumu piegādāšanu, lūdzu samainiet autoship statusu!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui dividing header"
  }, [_c('i', {
    staticClass: "marker icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n        Piegādes informācija un regularitāte\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "delivery-zone2"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "image content"
  }, [_c('div', {
    staticClass: "ui  image"
  }, [_c('img', {
    attrs: {
      "src": "https://api.memorywater.lv/img/documents/piegades-teritorija.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui dividing header"
  }, [_c('i', {
    staticClass: "shop icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n     Preces\n   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui dividing header"
  }, [_c('i', {
    staticClass: "money icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      Kopsavilkums\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('b', [_vm._v("Nākamā pasūtījuma summa:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-219ad713!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutoshipEditPage.vue
// module id = 326
// module chunks = 1